import { useEmbarcacaoGuinchosGuindastes } from "../../../../hooks/use-embarcacao-guinchos-guindastes";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  GUINCHOS_GUINDASTES_EMPTY_STATE,
  GUINCHOS_GUINDASTES_FIELDS,
  GUINCHOS_GUINDASTES_ID,
  GUINCHOS_GUINDASTES_LOADING_MESSAGE,
  GUINCHOS_GUINDASTES_TEST_ID,
  GUINCHOS_GUINDASTES_TITLE,
} from "./guinchos-guindastes-section.constants";

/** Seção Guincho Guindaste do detalhamento da embarcação: um cartão por registro, na ordem da fonte, somente para leitura. */
export function useGuinchosGuindastesSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, guinchosGuindastes, errorMessage, reload } =
    useEmbarcacaoGuinchosGuindastes(embarcacaoId);

  return {
    id: GUINCHOS_GUINDASTES_ID,
    title: GUINCHOS_GUINDASTES_TITLE,
    testId: GUINCHOS_GUINDASTES_TEST_ID,
    cardsTestId: `${GUINCHOS_GUINDASTES_TEST_ID}-blocks`,
    status,
    errorMessage,
    loadingMessage: GUINCHOS_GUINDASTES_LOADING_MESSAGE,
    emptyContent: GUINCHOS_GUINDASTES_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem registros.
    ultimaAtualizacao: guinchosGuindastes
      ? latestAtualizacao(
          guinchosGuindastes.flatMap((row) => [
            row.ultimaAtualizacao,
            row.atualizacaoGuinchoGuindaste,
          ]),
        )
      : undefined,
    cards: (guinchosGuindastes ?? []).map((registro, index) => {
      const testId = `${GUINCHOS_GUINDASTES_TEST_ID}-block-${index}`;

      return {
        testId,
        fieldsTestId: `${testId}-fields`,
        fields: buildDetailFields(
          registro,
          GUINCHOS_GUINDASTES_FIELDS,
          testId,
          EMPTY_FIELD_PLACEHOLDER,
        ),
      };
    }),
  };
}
